
export interface OrderItem {
  id?: number;
  drinkId: number;
  drinkName?: string;
  quantity: number;
  unitPrice: number;
  subtotal: number;
  specialInstructions?: string | null;
}
